// src/App.js
import React from 'react';
import './App.css';
import ChatDialog from './ChatDialog'; // Importer den nye komponenten

function App() {
  return (
    <div className="App">
      <h1>Dialog mellom Kunde og Selger</h1>
      <ChatDialog /> {/* Bruk komponenten her */}
    </div>
  );
}

export default App;